// app/frontend/stores/user.js
import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
    state: () => ({
        user: null,
    }),
    actions: {
        setUser(user) {
            if (!user) return;

            this.user = user;
        },
        clearUser() {
            this.user = null;
        },
        setLoginRedirectUrl(url) {
            sessionStorage.setItem('url', url);
        },
        resetLoginRedirectUrl() {
            sessionStorage.removeItem('url');
        },
    },
    getters: {
        isLoggedIn: (state) => state.user !== null,
        getUser: (state) => state.user,
        getUserLocale: () => ({ locale: 'en-CA' }),
        loginReturn: () => sessionStorage.getItem('url') || '/',
    },
});
